import React, { useState } from 'react';
import { PlatformSelector, MDMManualEnrollment } from './components';
import { MDMInstallerProps, PlatformType } from './types';

const MDMInstaller: React.FC<MDMInstallerProps> = (props) => {
  const [activeView, setActiveView] = useState<PlatformType>('IOS');

  const { client, siteId } = props;

  return (
    <div className="duration-bg-color mt-25 p15">
      <div className=" mb-15 flex col g20">
        <PlatformSelector
          activeView={activeView}
          onPlatformChange={setActiveView}
        />

        <MDMManualEnrollment
          activeView={activeView}
          isConfigurationPage={false}
          client={client}
          siteId={siteId}
        />
      </div>
    </div>
  );
};

export default MDMInstaller;
